/**
 * Element for column in list item component
 * 
 * Properties:
 * 
 *      type:             string, type of element (text, button, select)
 *      value:            string, active value e.g. selected value in select box
 *      title:            string, generell popup info for e.g. select box
 *      data:             array of objects containing data to display according to elements type
 * 
 *                          type text:
 *                            value:          string, value to set as argument in handler also used as name for DOM node
 *                            text:           string, content of text node
 *                            extraClasses:   string, space separated class names controlling text style attributes
 *                            title:          string, popup info
 *                            icon:           string, class name of icon (used instead of text to provide a single icon positioned together with text)
 *                            ref:            string, target of link for text or icon (text or icon works as hyper link)
 *                                                  NOTE: using # as ref is used to trigger callback instead of setting a link
 * 
 *                          type button:
 *                            value:          string, value to set as argument in handler also used as name for DOM node
 *                            title:          string, popup info
 *                            text:           string, button is a text-based button if set (NOTE: not implemented yet)
 *                            icon:           string, class name of icon
 *                            ref:            string, target link for button
 *                                                    NOTE: using # as ref is used to trigger callback instead of setting a link
 *                            extraClasses:   string, space separated class names controlling button style attributes (e.g. beautify for text-based buttons)
 * 
 *                          type select:
 *                            value:          string, value to set as argument in handler also used as name for DOM node
 *                            text:           string, content for option
 *                            disabled:       boolean, option can be disabled for selection
 * 
 *      handler:          function, callback to executed by click or change events in element receiving "value" as parameter
 *                        
 *      mediumWidth:      number, number of columns used for this element on big screens
 *      smallWidth:       number, number of columns used for this element on small screens
 *      extraTopClasses:  string, space separated class names controlling style attributes of whole block
 */

 import React from "react";
 import LargeButton from "./LargeButton";
 // @ts-ignore
import Checkins from "../pages/reservations/components/Checkins";
// @ts-ignore
import Biscuit from '../../utils/Biscuit';
// @ts-ignore
import {ADJUSTMENT_HELP_TEXT, HtmlTooltip} from "../../utils/HelperOld";
import Switchpaddle from "./switchpaddle";

type Props = {
    data?: any,
    extraTopClasses?: any,
    id?: any
    type?: string,
    title?: string,
    link?: string,
    largeWidth?: number,
    smallWidth?: number,
    mediumWidth?: number,
    handler?: any,
    extraData?: any,
    extraText?: string,
    _key?: string,
    listenPending?: boolean,
    itemPending?: boolean,
    badge?: string,
    value?: any,
    style?: React.CSSProperties,
}
 const ListItemElement = (props:Props) => {
  let extraClasses = props.extraTopClasses ? props.extraTopClasses : "";
  if(props.type === 'CheckInAddition') {
      let data = {
          app_user_role: props.data[0].app_user_role,
          dispatch: props.data[0].dispatch,
          checkout: props.data[0].checkout,
          setCheckout: props.data[0].setCheckout,
          setCheckoutReservation: props.data[0].setCheckoutReservation,
          setCheckoutCheckin: props.data[0].setCheckoutCheckin,
          setFilter: props.data[0].setFilter,
          filter: props.data[0].filter,
          setNKey: props.data[0].setNKey,
          sort: props.data[0].sort,
          setSort: props.data[0].setSort,
          _key: props.data[0]._key,
          locations: props.data[0].locations
      };
      return (
          <Checkins
              data={data}
              reservation={props.data[0].reservation}
              panel={false}
          />
      );
  }

  if(props.type !== "select" && props.type !== "bar" && props.type !== 'specialButtons' && props.type !== 'checkBox') {
   return (
       <div
       title={props.title} className={"list-item-block " + "large-" + props.largeWidth + " medium-" + props.mediumWidth + " small-" + props.smallWidth + " column " + extraClasses}>
        {props.data.map((obj:any, index:any) => {
            let extraStyle = {};
            if(typeof obj.extraStyle !== 'undefined'){
                extraStyle = obj.extraStyle;
            }
            let type:string = 'print';
            if(typeof obj.type !== 'undefined'){
                type = obj.type;
            }
         let extra_classes = obj.extraClasses ? obj.extraClasses : "";
            let target= typeof obj.target !== 'undefined'?obj.target:"";

         return (
             <div key={"list-item-element" + index} className="list-item-element" style={extraStyle}>
              {props.type === "text" &&
                  <>
                       {obj.ref && obj.text && typeof obj.icon === 'undefined' && (typeof obj.type === 'undefined' || obj.type !== 'info') &&
                            <a
                                href={obj.ref}
                                title={obj.title}
                                //name={obj.value}
                                target={target}
                                onClick={obj.ref === '#' ? ():void => {
                                props.handler(obj.value)} : ():void => {}}>
                                <span className={"test-class " + extra_classes}>
                                    {obj.text}
                                </span>
                            </a>
                       }
                       {typeof obj.ref === 'undefined' && typeof obj.icon === 'undefined' && obj.text && typeof obj.text !== 'object'  && (typeof obj.type === 'undefined' || obj.type !== 'info') &&
                           <span
                               className={extra_classes}
                               title={obj.title}
                               //name={obj.value}
                              >{obj.text}</span>
                       }
                      {typeof obj.ref === 'undefined' && typeof obj.icon === 'undefined' && obj.text && typeof obj.text === 'object'  && (typeof obj.type === 'undefined' || obj.type !== 'info') &&
                          <>
                              <span
                                  className={extra_classes}
                                  style={{float:"left",whiteSpace:"nowrap"}}
                                  title={obj.title[0]}
                                  //name={obj.value}
                              >
                                  {obj.text[0]}
                              </span><span className={extra_classes} style={{float:"left",padding:"0 5px 0 5px"}}> - </span>
                             <span
                                 className={extra_classes}
                                 title={obj.title[1]}
                                 //name={obj.value}
                                 style={{whiteSpace:"nowrap"}}>
                                  {obj.text[1]}
                             </span>
                          </>
                      }
                       {typeof obj.text2 !== 'undefined' &&
                            <><br /><span
                                className={extra_classes}
                                title={obj.title}
                               // name={obj.value}
                            >{obj.text2}</span></>
                       }
                       {obj.ref && obj.icon &&
                            <a
                                href={obj.ref}
                                title={obj.title}
                                //name={obj.value}
                                onClick={obj.ref === '#' ? () => {obj.handler(obj.value)} : () => {}}>
                                <i className={obj.icon + " " + extra_classes}>
                                    {typeof obj.text === 'undefined' ? "" : obj.text}
                                </i>
                            </a>
                       }
                      {typeof obj.type !== 'undefined' && obj.type === 'info' && typeof obj.show !== 'undefined' && obj.show && // @ts-ignore
                          <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={obj.text}/>}</React.Fragment>} enterDelay={200} leaveDelay={500}>
                              <label className="inb-form__controlLabel hide-for-small-only" style={{maxHeight:"20px",marginTop:"-9px"}}>
                                  <a data-tooltip-id="my-tooltip-data-html">
                                      <i className="inb-ico fi fi-info" style={{fontSize:"1.2rem"}}> </i>
                                  </a>
                                  {/* <i className="inb-ico fi fi-info"> </i>*/}
                              </label>
                          </HtmlTooltip>
                      }
                       {typeof obj.ref === 'undefined' && obj.icon &&
                            <i className={obj.icon + " " + extra_classes} title={obj.title}
                               // name={obj.value}
                            >{
                                    typeof obj.text === 'undefined' ? () => {} : obj.text}
                            </i>
                       }
                  </>
              }
              {props.type === "function" &&
                 <>{typeof obj.ref !== 'undefined'?<>
                     <a href={obj.ref}>
                     <span
                         className={extra_classes}
                         title={obj.title}
                         //name={obj.value}
                     >{obj.text}</span>
                     </a>
                 </>: <>
                     <span
                         className={extra_classes}
                         title={obj.title}
                         //name={obj.value}
                     >{obj.text}</span>
                 </>}
                 </>

              }
              {props.type === "button" &&
              <>
               {obj.text &&
                   <LargeButton
                       link={obj.ref}
                       icon={obj.icon}
                       title={obj.title}
                       name={obj.value}
                       beautify={obj.beautify}
                       handler={obj.handler !== 'undefined'?obj.handler:props.handler}
                       round={typeof obj.round !== 'undefined'?obj.round:false}
                       type={type}
                   />
               }
               {typeof obj.text === 'undefined' && (typeof obj.round === 'undefined' || obj.round === false) &&
                    <a
                       // name={obj.value}
                        href={obj.ref}
                        onClick={obj.ref === '#' ? () => {props.handler(obj.value)} : () => {}}>
                        <i className={obj.icon}> </i>
                    </a>
               }

              </>
              }
                 {props.type === 'numberEdit' &&
                 <>
                     <div className="float-left">
                 <input type="number" className="float-left width-50" onChange={(e: React.ChangeEvent<HTMLInputElement>):any => props.handler(e,props.extraData)} style={props.extraText !== null?{width:"50%"}:{}} /> { props.extraText !== null && <span className="padding-left-10 padding-top-2" style={{paddingTop: "30px",
                         lineHeight: "30px"}}>{props.extraText}</span>}
                     </div>
                 </>
             }

             </div>
         )
        })
        }

       </div>
   );
  } else {
      if(props.type === 'specialButtons')
      {
          let multi:boolean = false;
          if(props.data.length > 1){
             multi = true
          }
          let counter:number = 0;
          return (
              <>
              <div className={"large-" + props.largeWidth + " medium-" + props.mediumWidth + " small-" + props.smallWidth + " " + extraClasses + " column item-button-group "}>
                  {props.data.map((obj:any) => {
                      let classN:string = "button-container ";
                      if(multi && counter === 0){
                          classN = "button-container btn-grp-2"
                      }
                      counter++;
                      return(
                          <>
                      <div className={classN}>
                          <a
                             // name={obj.value}
                              href={obj.ref}
                              onClick={obj.ref === '#' ? () => {obj.handler(obj.value,props._key)} : () => {}} id={"btn_"+obj.value}>
                              <button type="button" className={obj.extraClasses} title={obj.title}>
                                  <div className={obj.icon}> </div>
                              </button>
                          </a>
                      </div>
                          </>
                          )})}
                  </div>
                  </>
          );
      }
      if(props.type === 'checkBox')
      {
          return (
              <>
                  <div className={"large-" + props.largeWidth + " medium-" + props.mediumWidth + " small-" + props.smallWidth  + " column item-button-group "+ " " + extraClasses} style={props.style?props.style:{}}>
                      <Switchpaddle
                          name={props.data.name}
                          value={props.data.value}
                          onChange={props.data.onChange}
                          largeWidth={props.largeWidth}
                          mediumWidth={props.mediumWidth}
                          smallWidth={props.smallWidth}
                          paddle={false}
                          label={''}/>
                  </div>
              </>
          );
      }
   if (props.type === 'select') {
    return (
        <>
         <div
             title={props.title}
             className={"list-item-block " + "large-" + props.largeWidth + " medium-" + props.mediumWidth + " small-" + props.smallWidth + " column " + extraClasses}>
             {props.listenPending && props.itemPending ?
                 <>
                     <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                 </>:<>
          <div className={"inb-status-select" + (props.badge?" inb-before-badge":"")} data-inb-status={props.value}>
           <select className="inb-status-select" value={props.value} title={props.title} onChange={(e) => {props.handler(e,props.extraData)} }>
               {props.data.map((obj:any) => {
             return (<>
                  {obj.selected &&
                  <option value={obj.value} disabled={obj.disabled} selected>{obj.text}</option>
                  }
                  {!obj.selected &&
                  <option value={obj.value} disabled={obj.disabled}>{obj.text}</option>
                  }
                 </>
             )
            })}
           </select>
          </div></>}
         </div>
        </>
    );
   }
   if (props.type === 'bar') {
    return (
         <>
          <div
              title={props.title}
              className={"list-item-block " + "large-" + props.largeWidth + " medium-" + props.mediumWidth + " small-" + props.smallWidth + " column " + extraClasses}>
              {props.data.map((obj:any, index:any) => {
                  return (
                      <>
                          <div className={"inb-contingent-progress" + "-" + obj.extra}
                               style={{marginBottom: "-1rem"}}>
                              <div
                                  className={"progress beautify beautify-"+ Biscuit.get('user.client_id')}
                                  role="progressbar"
                                  tabIndex={0}>
                                  <div className="progress-bars">
                                      <span className="progress-meter" style={{width: "0%"}}></span>
                                  </div>
                                  <p className={"progress-meter-text " + obj.extraClasses}>
                                      {obj.text}
                                  </p>
                              </div>
                          </div>
                      </>
                  )
              })}
          </div>
         </>
    )
   } else {
       return (<></>);
   }

  }
 };
 export default ListItemElement;
